var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.isObjectPage)?_c('ObjectPageHeaderMobile'):_c('PageHeaderMobile'),_c('MobileLeftMenu'),_c('MobileRightMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }